<template>
  <div>
    <attachments :attachments="attachments" :editable="editablePermission && editableAttachments" />

    <attachments
      v-if="otherAttachments.length"
      :title="attachmentSubdocumentName"
      :attachments="otherAttachments"
      :editable="false"
      :use-index-as-order="true"
    />
  </div>
</template>

<script>
import { mapState } from 'vuex';

import Attachments from '@/components/document/Attachments';
import { EntityType } from '@/enums/entityType.enum';
import { ModuleName } from '@/enums/moduleName.enum';
import { PublicSettings } from '@/enums/publicSettings.enum';
import { tryParseInt } from '@/utils/number';

// @vuese
// Załączniki wniosku
// @group Document
export default {
  components: { Attachments },
  computed: mapState({
    attachments(state) {
      return state.document.attachment.list.filter(
        attachment =>
          attachment.entityType === EntityType.DOCUMENT &&
          attachment.entityId.toString() === this.$route.params.documentId.toString()
      );
    },
    otherAttachments(state) {
      const attachments = state.document.attachment.list.filter(
        attachment => attachment.entityId.toString() !== this.$route.params.documentId.toString()
      );
      attachments.sort((prev, next) => tryParseInt(prev.entityId) > tryParseInt(next.entityId));
      return attachments;
    },
    hasChildren: state => !!state.document.data?.children?.length,
    editablePermission: state => state.auth.checkPermission.permissions['ATTACHMENT.ADD'],
    editableAttachments: state => state.document.data.status.stage?.module?.name === ModuleName.edit,
    attachmentSubdocumentName(state) {
      return this.hasChildren
        ? state.setting.settings[PublicSettings.PROCEDURE_ATTACHMENT_SUBDOCUMENT_NAME]?.value ||
            'Załączniki subdokumentów'
        : 'Załączniki wniosku';
    }
  })
};
</script>
